import { useMutation } from "@tanstack/react-query";
import { videoDelete } from "common/api/sakusas/sakusas_video";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseSakusasVideoDeleteParams = {
  invalidateKeys?: string[];
};

export const useSakusasVideoDelete = (
  hookParams?: UseSakusasVideoDeleteParams
) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: videoDeleteMutate } = useMutation({
    mutationFn: async (id: string) => await videoDelete(id),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
    },
  });

  return { videoDeleteMutate };
};
